// removed by extract-text-webpack-plugin
module.exports = {"gwTileHeaderIcon":"tile-header-icon-hashed__gwTileHeaderIcon__-ReS6"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/HeaderIcon/tile-header-icon-hashed.scss
// module id = 718
// module chunks = 0